// Static placeholder data for TipTap editor
const appLinks = [
  {
    id: 'android_app_link',
    label: 'android_app_link',
    description: 'Download button/link for the Android app'
  },
  {
    id: 'ios_app_link',
    label: 'ios_app_link',
    description: 'Download button/link for the iOS app'
  }
]

const conferencePlaceholderItems = [
  {
    id: 'conference_name',
    label: 'conference_name',
    description: 'Conference Name'
  },
  {
    id: 'conference_code',
    label: 'conference_code',
    description: 'Short code for the conference'
  },
  {
    id: 'conference_dates',
    label: 'conference_dates',
    description: 'Conference start and end date'
  },
  {
    id: 'conference_deadline',
    label: 'conference_deadline',
    description: 'Conference end date or Registration Deadline'
  }
]

export const customEmailsPlaceholders = [...conferencePlaceholderItems, ...appLinks]

export const emailTemplatePlaceholderItems = [
  ...conferencePlaceholderItems,
  {
    id: 'HTML_FORM_LINK',
    label: 'HTML_FORM_LINK',
    description: 'Link used by speakers/exhibitors/sponsors to submit their profile details'
  },
  ...appLinks
]

// Static placeholder data for TipTap editor
export const exportLeadsPlaceholderItems = [
  {
    id: 'contacts',
    label: 'contacts',
    description: 'Scanned lead/contact details'
  },
  ...conferencePlaceholderItems,
  ...appLinks
]

export const welcomeEmailTemplatePlaceholderItems = [
  {
    id: 'admin_name',
    label: 'admin_name',
    description: 'Name of the conference admin'
  },
  {
    id: 'email',
    label: 'email',
    description: 'Registered email of the admin'
  },
  {
    id: 'password',
    label: 'password',
    description: 'Temporary password for login'
  },
  {
    id: 'hyperlink_to_dashboard',
    label: 'hyperlink_to_dashboard',
    description: 'Button/link to access the admin dashboard'
  },
  {
    id: 'activation_link',
    label: 'activation_link',
    description: 'Link to set a new password and activate the account (expires in 48 hours)'
  }
]
